module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAYCAYAAADpnJ2CAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAPZJREFUeNq8lo0NgyAQRg8noBt0gzqCI3QERnAERnAER+gGtRvYDRjBTkCPBBNi5DwQvORL/EGf94BEYa2FzGoxMjiX/lpszIJRAoF3d8B42QPy64t5Ygy4DjGzrVcjRnoOrMC2EqxfQVugiy4IWnwTQAFLqZ1DhUfArsB8AZW9i0OmQnUEiwGdDpMAM7H52ouIbPwO82busZvf1LwivmZgdgcpoW5y1E6pwIZo3mnqoXQxvupVskPOIOmXfXWloVp1pVJKbRWllNoqSqlVO6UabRLHj5jPmSlsMp5xC+h3JdBgdC5QnPhrm3x07Q5DtUvqQ38BBgAtugVt3YlvUQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/home/arrow2.png
// module id = a2Td
// module chunks = 51